import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import bookingActions from 'actions/bookings/actions'
import promoActions from 'actions/promocodes/actions'
import BookingPaymentForm from './form'

// @TODO: Loading?
const BookingPayment = ({ bookingDetails, fetchPaymentDetails, id, user, payProposal, notification: { type }, clientApplyCode }) => {
  const [paymentOption, setPaymentOption] = useState('credit-card')
  useEffect(() => { fetchPaymentDetails({ id }) }, []);

  return (
    <div className="booking-payment-form">
      {type === 'success' && <Redirect to="/client?view=confirmed" />}
      <BookingPaymentForm
        form="client-booking-payment-checkout"
        onSubmit={values => payProposal({ ...values, ...bookingDetails, id, user, paymentType: paymentOption })}
        bookingDetails={bookingDetails}
        paymentOption={paymentOption}
        setPaymentOption={setPaymentOption}
        clientApplyCode={clientApplyCode}
        id={id}
      />
    </div>
  )
}

BookingPayment.propTypes = {
  bookingDetails: PropTypes.object,
  id: PropTypes.string,
  fetchPaymentDetails: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  payProposal: PropTypes.func.isRequired,
  notification: PropTypes.object.isRequired,
  clientApplyCode: PropTypes.func
}

const mapStateToProps = ({ bookings, auth, notification }) => ({
  bookingDetails: bookings.bookingDetails,
  user: auth.user,
  notification,
})

const mapDispatchToProps = {
  fetchPaymentDetails: bookingActions.fetchClientProposalPaymentDetails,
  payProposal: bookingActions.payClientProposal,
  clientApplyCode: promoActions.clientApplyCode
}

export default connect(mapStateToProps, mapDispatchToProps)(BookingPayment)
